import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from "react-router-dom";

import {
  ProtectedRoute,
} from "./components";
import Layout from "@components/layout/Layout";
import { RoutesList } from "./routes/Routes.ts";
import { UploadPhoto } from "@components/pages/waste/uploadPhoto/UploadPhoto";
import { BeforeYouStart} from "@components/pages/waste/beforeYouStart/BeforeYouStart";
import { WasteDetails } from "@components/pages/waste/wasteDetails/WasteDetails";
import { Confirmation } from "@components/pages/waste/confirmation/Confirmation";
import { YourDetails } from "@components/pages/waste/yourDetails/YourDetails";
import { TestLandingPage } from "@components/pages/waste/testLandingPage/TestLandingPage";
import { basename } from "./routes/basename.ts";
import ErrorScreen, { ErrorType } from "@components/pages/not-found/ErrorScreen";

const router = createBrowserRouter(
  createRoutesFromElements(
    
    <Route element={<Layout/>}>
      <Route
        path={RoutesList.TEST_LANDING_PAGE}
        element={<TestLandingPage />}
      />
      <Route path={RoutesList.WASTE_HOME} element={<BeforeYouStart />} />
      <Route path={RoutesList.UPLOAD_PHOTO} element={<UploadPhoto />} />
      <Route path={RoutesList.WASTE_DETAILS} element={<WasteDetails />} />
      <Route path={RoutesList.YOUR_DETAILS} element={<YourDetails />} />
      <Route
        path="/callbacks"
        element={<ProtectedRoute>{null}</ProtectedRoute>}
      />
      <Route path={RoutesList.CONFIRMATION} element={<Confirmation />} />
      <Route path={RoutesList.INTERNAL_SERVER_ERROR} element={<ErrorScreen errorType={ErrorType.INTERNAL_SERVER_ERROR} />}/>
      <Route path={RoutesList.NOT_FOUND} element={<ErrorScreen errorType={ErrorType.NOT_FOUND} />} />
    </Route>,
  ),
  {basename}
);

  function App() {
    return (
      <>
        <RouterProvider router={router}/>
      </>
    );
  }
  
  export default App;